import { render, staticRenderFns } from "./Effects.vue?vue&type=template&id=9e294502&scoped=true&"
import script from "./Effects.vue?vue&type=script&lang=js&"
export * from "./Effects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e294502",
  null
  
)

export default component.exports